var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 16.0194C28.5938 17.0304 28.2756 18.0452 27.6392 18.8578C27.5199 19.0173 26.9631 19.6744 26.5256 20.1021L26.2869 20.3354C22.946 23.8775 14.6335 29.2044 10.4176 30.9113C10.4176 30.9502 7.91193 31.965 6.71875 32H6.55966C4.73011 32 3.01989 30.993 2.14489 29.3599C1.66761 28.4617 1.23011 25.8566 1.19034 25.8216C0.832385 23.4848 0.59375 19.9077 0.59375 15.9806C0.59375 11.8629 0.832386 8.12637 1.26989 5.83232C1.26989 5.79344 1.70739 3.6938 1.9858 2.99393C2.4233 1.98688 3.21875 1.12758 4.21307 0.583233C5.00852 0.1983 5.84375 0 6.71875 0C7.63352 0.0427704 9.34375 0.622114 10.0199 0.894289C14.4744 2.6051 22.9858 8.20413 26.2472 11.6258C26.804 12.1701 27.4006 12.835 27.5597 12.9866C28.2358 13.842 28.5938 14.8919 28.5938 16.0194Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ab7db63c8aa4042503844916df5b0ad1.svg";
export { ForwardRef as ReactComponent };